import { createSlice } from '@reduxjs/toolkit';
import {
  CopyAction,
  CopyResolveAction,
  GetActionHistoryAction,
  GetActionHistoryResolveAction,
  GetWorkOrderModelAction,
  GetWorkOrderModelResolveAction,
  IInterLabState,
  TransferAction,
  TransferResolveAction,
  UpdateAllLabSampleModelAction,
  UpdateLabSampleModelAction,
} from './types';

const initialState: IInterLabState = {
  workOrder: undefined,
  status: {
    busy: false,
  },
};

const slice = createSlice({
  name: 'interLab',
  initialState,
  reducers: {
    getWorkOrder(state, action: GetWorkOrderModelAction) {},
    getWorkOrderResolve(state, action: GetWorkOrderModelResolveAction) {
      action.payload.samples.forEach((sample) => (sample.checked = true));

      state.workOrder = action.payload;
    },
    clearWorkOrder(state) {
      state.workOrder = undefined;
    },
    updateSample(state, { payload: sample }: UpdateLabSampleModelAction) {
      if (state.workOrder) {
        const newSamples = [...state.workOrder.samples];
        const index = newSamples.findIndex((x) => x.id === sample.id);

        newSamples[index] = sample;

        state.workOrder.samples = newSamples;
      }
    },
    updateAllSample(state, { payload: checked }: UpdateAllLabSampleModelAction) {
      if (state.workOrder) {
        state.workOrder.samples.forEach((sample) => (sample.checked = checked));
      }
    },
    transfer(state, action: TransferAction) {
      state.status.busy = true;
    },
    transferResolve(state, action: TransferResolveAction) {
      state.workOrder = action.payload;
      state.status.busy = false;
    },
    transferReject: (state) => {
      state.status.busy = false;
    },
    copy(state, action: CopyAction) {
      state.status.busy = true;
    },
    copyResolve(state, action: CopyResolveAction) {
      state.workOrder = action.payload;
      state.status.busy = false;
    },
    copyReject: (state) => {
      state.status.busy = false;
    },
    getActionHistory(state, action: GetActionHistoryAction) {
      state.status.busy = true;
    },
    getActionHistoryResolve(state, action: GetActionHistoryResolveAction) {
      state.workOrder!.actionHistories = action.payload;
      state.status.busy = false;
    },
  },
});

export const { actions, reducer } = slice;
export default slice.reducer;
